import {useSelector} from 'react-redux';

import {UserCountKey, UserTariffCountKey} from './IUser';
import {userSelector} from './authSlice';
import {isUnderLimit} from '../lib/tariffLimit';

const useIsUnderUserLimit = (limitKey: UserTariffCountKey, countKey: UserCountKey): boolean => {
    const user = useSelector(userSelector);

    return isUnderLimit(user?.tariff?.[limitKey], user?.[countKey]);
};

export default useIsUnderUserLimit;
